"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStatePovertyLevel;
/* eslint-disable no-lonely-if,brace-style */

function getStatePovertyLevel(dirtyState, persons) {
  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'monthly';
  if (dirtyState == null) throw new Error('Missing State');
  if (persons == null) throw new Error('Missing Persons Count');
  var state = dirtyState.toUpperCase(); // NOTE: these values should match poverty guidelines w/o multiplier!
  // https://aspe.hhs.gov/poverty-guidelines

  var cutoff = null;

  if (state === 'AK') {
    // WARNING: make sure these are poverty guidelines w/o multiplier!
    if (persons === 1) {
      cutoff = 16090;
    } else if (persons === 2) {
      cutoff = 21770;
    } else if (persons === 3) {
      cutoff = 27450;
    } else if (persons === 4) {
      cutoff = 33130;
    } else if (persons === 5) {
      cutoff = 38810;
    } else if (persons === 6) {
      cutoff = 44490;
    } else if (persons === 7) {
      cutoff = 50170;
    } else if (persons === 8) {
      cutoff = 55850;
    } else {
      cutoff = 55850 + 5680 * (persons - 8);
    }
  } else if (state === 'HI') {
    // WARNING: make sure these are poverty guidelines w/o multiplier!
    if (persons === 1) {
      cutoff = 14820;
    } else if (persons === 2) {
      cutoff = 20040;
    } else if (persons === 3) {
      cutoff = 25260;
    } else if (persons === 4) {
      cutoff = 30480;
    } else if (persons === 5) {
      cutoff = 35700;
    } else if (persons === 6) {
      cutoff = 40920;
    } else if (persons === 7) {
      cutoff = 46140;
    } else if (persons === 8) {
      cutoff = 51360;
    } else {
      cutoff = 51360 + 5220 * (persons - 8);
    }
  } else {
    // WARNING: make sure these are poverty guidelines w/o multiplier!
    if (persons === 1) {
      cutoff = 12880;
    } else if (persons === 2) {
      cutoff = 17420;
    } else if (persons === 3) {
      cutoff = 21960;
    } else if (persons === 4) {
      cutoff = 26500;
    } else if (persons === 5) {
      cutoff = 31040;
    } else if (persons === 6) {
      cutoff = 35580;
    } else if (persons === 7) {
      cutoff = 40120;
    } else if (persons === 8) {
      cutoff = 44660;
    } else {
      cutoff = 44660 + 4540 * (persons - 8);
    }
  }

  return period === 'monthly' ? Number(Number(cutoff * multiplier / 12).toFixed(2)) : Number(cutoff * multiplier).toFixed(2);
}